__turbopack_context__.v({
  "CardBlock": "CardBlock-module__B1jbDW__CardBlock",
  "CardBlock__inner": "CardBlock-module__B1jbDW__CardBlock__inner",
  "CardBlock__layout": "CardBlock-module__B1jbDW__CardBlock__layout",
  "CardItem": "CardBlock-module__B1jbDW__CardItem",
  "basic": "CardBlock-module__B1jbDW__basic",
  "basic_4": "CardBlock-module__B1jbDW__basic_4",
  "default": "CardBlock-module__B1jbDW__default",
  "default_4": "CardBlock-module__B1jbDW__default_4",
  "horizontal": "CardBlock-module__B1jbDW__horizontal",
  "text-center": "CardBlock-module__B1jbDW__text-center",
  "text-left": "CardBlock-module__B1jbDW__text-left",
  "text-right": "CardBlock-module__B1jbDW__text-right",
  "wbcard": "CardBlock-module__B1jbDW__wbcard",
});
